import React, { Component } from 'react'
import { connect } from 'react-redux'

import '../../assets/css/tor-template-list.css'
import { DatePicker, Select, InputDecimal, DropDownMuti } from '../../components/core'
import $ from 'jquery'
import { SecureGateRoute, BreadCrumb, DetailBotLogModal } from '../../components'
import { searchReportReceiptAction } from '../../redux/actions/ReportAction'
import ReceiptTablePage from '../../components/ReportReceipt/ReceiptTablePage'
import { AppSettings } from '../../configs'
import { Storage } from '../../configs'
import moment from 'moment'
import { msg } from '../../components/Notifications/MsgBox'
import { STOP_LOADING } from '../../redux/actions/actionTypes'

class ReportReceiptScreen extends Component {
    constructor(props) {
        super(props)

        this.state = {
            searchConditionModel: {
                PO_CONTRACT_NO: '',
                HEADER_TEXT: '',
                REQUISITIONER: '',
                PURCH_GROUP: '',
                MOM_DOC_NO: '',
                RRS_DOC_NO: '',
                CREATE_DATE_FROM: moment(new Date(new Date().getFullYear(), new Date().getMonth() - 3, new Date().getDay() + 1, 0, 0)).format('DD/MM/YYYY'),
                CREATE_DATE_TO: moment(new Date()).format('DD/MM/YYYY'),
                MUTI_STATUS: '',
                CREATE_BY: '',
                UNITCODE: Storage.getUser().unitCode,
                UNITCODE_CREATE: '',
            },
            
        }

        //create date
        this.create_date_from_ref = React.createRef();
        this.create_date_to_ref = React.createRef();
        //Edit Date 
        this.edit_date_from_ref = React.createRef();
        this.edit_date_to_ref = React.createRef();

        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleDropdownMutiChange = this.handleDropdownMutiChange.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.handleClear = this.handleClear.bind(this);
        
    }
    async componentDidMount() {
        let { searchConditionModel } = this.state;
        await this.props.searchReport(searchConditionModel);

        $(function () {
            window.onComponentDidMount()
        })
    }

    handleInputChange(event) {
        let { searchConditionModel } = this.state;
        const target = event.target
        let value = target.type === 'checkbox' ? target.checked : target.value
        const name = target.name

        //check date
        if (target.className) {
            if ((target.className.indexOf("js-datepicker") > -1 || target.className.indexOf("js-datepicker-all") > -1) && (value.toString()).indexOf("/") > 0) {
                let dateData = (value.toString()).split("/")
                let dateDataLength = dateData.length
                if (dateDataLength === 3) {
                    if (moment(value, 'DD/MM/YYYY').isValid()) {
                        value = moment(value, 'DD/MM/YYYY').format('DD/MM/YYYY')
                    }
                }
            }
        }

        searchConditionModel[name] = value;

        this.setState({
            searchConditionModel: searchConditionModel
        })
    }

    handleDropdownMutiChange(event) {
        let { searchConditionModel } = this.state;
        let value=null
        if(event)
        {
            const target = event.target
            value = event
        }

        searchConditionModel['MUTI_STATUS'] = value


        this.setState({
            searchConditionModel: searchConditionModel
        })

    }

    async handleSearch(event) {

        if(this.state.searchConditionModel.PO_CONTRACT_NO == '' &&
            this.state.searchConditionModel.HEADER_TEXT == '' &&
            this.state.searchConditionModel.REQUISITIONER == '' &&
            this.state.searchConditionModel.PURCH_GROUP == '' &&
            this.state.searchConditionModel.MOM_DOC_NO == '' &&
            this.state.searchConditionModel.RRS_DOC_NO == '' &&
            this.state.searchConditionModel.CREATE_DATE_FROM == '' &&
            this.state.searchConditionModel.CREATE_DATE_TO == '' &&
            this.state.searchConditionModel.MUTI_STATUS == '' &&
            this.state.searchConditionModel.CREATE_BY == '' &&
            this.state.searchConditionModel.UNITCODE_CREATE == '')
        {
            msg.error("กรุณาระบุข้อมูลค้นหาอย่างน้อย 1 Parameter")
            return;
        }

        let searchConditionModel = this.state.searchConditionModel;

        let list_status=[];
        if(this.state.searchConditionModel.MUTI_STATUS)
        {
            this.state.searchConditionModel.MUTI_STATUS.map((item, key) =>
                list_status.push(item.value)
            );
        }

        let conditionSearch = {
            ...searchConditionModel,
            MUTI_STATUS : list_status.toString()
        }

        event.preventDefault();
        await this.props.searchReport(conditionSearch).catch(() => {
                msg.error("เกิดข้อผิดพลาด")
            }
        );
        if(this.props.resultSearch && this.props.resultSearch.length === 0)
        {
            msg.error("ไม่พบข้อมูล")
        }
        
    }

    statusOptions = () => {
        return Promise.resolve([
            {
                value: "DRAF",
                label: "Draft"
            },
            {
                value: "WVER",
                label: "Waiting for Verification"
            },
            {
                value: "VERI",
                label: "Verifying"
            },
            {
                value: "REJT",
                label: "Rejected"
            },
            {
                value: "BCFM",
                label: "Automatically process"
            },
            {
                value: "MCFM",
                label: "Manually process"
            },
            {
                value: "MCOM",
                label: "Manual Completed"
            },
            {
                value: "BPRO",
                label: "BOT Processing"
            },
            {
                value: "BCOM",
                label: "BOT Completed"
            },
            {
                value: "BPCO",
                label: "BOT Partial Completed"
            },
            {
                value: "BINC",
                label: "BOT Incomplete"
            },
            // {
            //     value: "DELE",
            //     label: "Delete"
            // },
            {
                value: "WACCEPT",
                label: "Waiting for Accept"
            },
            {
                value: "ACCEPT",
                label: "Accept"
            },
            {
                value: "DECL",
                label: "Decline"
            },
            {
                value: "COMPLETE",
                label: "Complete"
            },
            {
                value: "DELE",
                label: "Delete"
            }
        ]);
    }
    
    async handleClear(event) {

        event.preventDefault()
        await this.setState({
            searchConditionModel: {
                PO_CONTRACT_NO: '',
                HEADER_TEXT: '',
                REQUISITIONER: '',
                PURCH_GROUP: '',
                MOM_DOC_NO: '',
                RRS_DOC_NO: '',
                CREATE_DATE_FROM: moment(new Date(new Date().getFullYear(), new Date().getMonth() - 3, new Date().getDay() + 1, 0, 0)).format('DD/MM/YYYY'),
                CREATE_DATE_TO: moment(new Date()).format('DD/MM/YYYY'),
                MUTI_STATUS: '',
                CREATE_BY: '' ,
                UNITCODE: Storage.getUser().unitCode,
                UNITCODE_CREATE: '',
            }
        })

        
        let { searchConditionModel } = this.state;
        await this.props.searchReport(searchConditionModel);

    }
    
    render () {
        let { searchConditionModel } = this.state

        return (
            <div className="tor tor-template-list">
                <SecureGateRoute/>
                <div id="main-content">
                    <div className="page-body">
                        <BreadCrumb breadcrumb={ [
                            { name: 'RRS Home', url: AppSettings.defaultUrl },
                            { name: 'รายงานข้อมูลบันทึกการประชุม', url: '' },
                        ] }></BreadCrumb>

                        <div className="sp-page-header-panel row">
                            <div className="col-md-5 sp-page-header">
                                <h1 className="sp-page-header1">รายงานข้อมูลบันทึกการประชุม</h1>
                            </div>
                        </div>

                        <div className="sp-page-result-container">

                            <div className="row">
                                <div className="col-md-6">
                                    <div className="rrs-detail-data">
                                        <label htmlFor="PO_CONTRACT_NO" className="rrs-label mb-0">PO /Contract No.</label>
                                    </div>
                                    <div className="rrs-detail-data">
                                        <div className="form-group">
                                            <InputDecimal
                                                type="text"
                                                id="PO_CONTRACT_NO"
                                                name="PO_CONTRACT_NO"
                                                className="form-control"
                                                placeholder="ข้อมูล Purchase / Contract Number"
                                                pattern="[0-9]*"
                                                inputMode="decimal"
                                                floatingPoint={ 0 }
                                                maxLength="10"
                                                value={ searchConditionModel.PO_CONTRACT_NO }
                                                onChange={ this.handleInputChange }
                                            />
                                        </div>
                                    </div>

                                </div>
                                <div className="col-md-6">
                                    <div className="rrs-detail-data">
                                        <label htmlFor="HEADER_TEXT" className="rrs-label mb-0">ชื่องาน</label>
                                    </div>
                                    <div className="rrs-detail-data">
                                        <div className="form-group">

                                            <input
                                                type="text"
                                                id="HEADER_TEXT"
                                                name="HEADER_TEXT"
                                                className="form-control"
                                                placeholder="ชื่องาน"
                                                value={ searchConditionModel.HEADER_TEXT }
                                                onChange={ this.handleInputChange }
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-md-6">
                                    <div className="rrs-detail-data">
                                        <label htmlFor="REQUISITIONER"
                                               className="rrs-label mb-0">หน่วยงานเจ้าของเรื่อง/Requisitioner
                                        </label>
                                    </div>
                                    <div className="rrs-detail-data">
                                        <div className="form-group">
                                            <input
                                                type="number"
                                                id="REQUISITIONER"
                                                name="REQUISITIONER"
                                                className="form-control"
                                                placeholder="รหัสหน่วยงาน ตย. 80000636 "
                                                value={ searchConditionModel.REQUISITIONER }
                                                onChange={ this.handleInputChange }
                                            />
                                        </div>
                                    </div>

                                </div>
                                <div className="col-md-6">
                                    <div className="rrs-detail-data">
                                        <label htmlFor="PURCH_GROUP" className="rrs-label mb-0">Purchasing Group
                                        </label>
                                    </div>
                                    <div className="rrs-detail-data">
                                        <div className="form-group">
                                            <input
                                                type="text"
                                                id="PURCH_GROUP"
                                                name="PURCH_GROUP"
                                                className="form-control"
                                                placeholder="ข้อมูล Purch. Group ตย. 110"
                                                value={ searchConditionModel.PURCH_GROUP }
                                                onChange={ this.handleInputChange }
                                            />

                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-md-6">
                                    <div className="rrs-detail-data">
                                        <label htmlFor="MOM_DOC_NO" className="rrs-label mb-0">MOM Doc No.</label>
                                    </div>
                                    <div className="rrs-detail-data">
                                        <div className="form-group">

                                            <input
                                                type="text"
                                                id="MOM_DOC_NO"
                                                name="MOM_DOC_NO"
                                                className="form-control"
                                                placeholder="MOM Doc No."
                                                value={ searchConditionModel.MOM_DOC_NO }
                                                onChange={ this.handleInputChange }
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="rrs-detail-data">
                                        <label htmlFor="RRS_DOC_NO" className="rrs-label mb-0">RRS Doc No.</label>
                                    </div>
                                    <div className="rrs-detail-data">
                                        <div className="form-group">
                                            <input
                                                type="text"
                                                id="RRS_DOC_NO"
                                                name="RRS_DOC_NO"
                                                className="form-control"
                                                placeholder="RSS Doc No."
                                                value={ searchConditionModel.RRS_DOC_NO }
                                                onChange={ this.handleInputChange }
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-md-6">
                                    <div className="rrs-detail-data">
                                        <label htmlFor="gr_post_date" className="rrs-label mb-0">Create Date</label>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-1 text-right">
                                            <span style={ { fontSize: '1rem' } }>From:</span>
                                        </div>
                                        <div className="col-md-5">
                                            <DatePicker
                                                name="CREATE_DATE_FROM"
                                                id="CREATE_DATE_FROM"
                                                placeholder="dd/mm/yyyy"
                                                data-date-format="dd/mm/yyyy"
                                                value={ searchConditionModel.CREATE_DATE_FROM }
                                                onChange={ this.handleInputChange }
                                                onBlur={ this.handleInputChange }
                                                doctype={ '*' }
                                                tagid="search.CREATE_DATE_FROM"
                                                ref={ this.create_date_from_ref }
                                            />
                                        </div>
                                        <div className="col-md-1 text-right">
                                            <span style={ { fontSize: '1rem' } }>To:</span>
                                        </div>
                                        <div className="col-md-5">
                                            <DatePicker
                                                name="CREATE_DATE_TO"
                                                id="CREATE_DATE_TO"
                                                placeholder="dd/mm/yyyy"
                                                data-date-format="dd/mm/yyyy"
                                                value={ searchConditionModel.CREATE_DATE_TO }
                                                onChange={ this.handleInputChange }
                                                onBlur={ this.handleInputChange }
                                                doctype={ '*' }
                                                tagid="search.CREATE_DATE_TO"
                                                ref={ this.create_date_to_ref }
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="rrs-detail-data">
                                        <label htmlFor="MUTI_STATUS" className="rrs-label mb-0">Status</label>
                                    </div>
                                    <div className="rrs-detail-data">
                                        <div className="form-group">

                                            <DropDownMuti
                                                loadOptions={ this.statusOptions }
                                                id="MUTI_STATUS"
                                                value={ this.state.searchConditionModel.MUTI_STATUS }
                                                className="form-control"
                                                placeholder=""
                                                onChange={ this.handleDropdownMutiChange }
                                                // onChange={this.handleChange('runningNoSelectedOptions')}
                                                // value={this.state.runningNoSelectedOptions}
                                            >
                                            </DropDownMuti>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="row">
                                    <div className="col-md-6">
                                        <div className="rrs-detail-data">
                                            <label htmlFor="CREATE_BY" className="rrs-label mb-0">RRS Create By</label>
                                        </div>
                                        <div className="rrs-detail-data">
                                            <div className="form-group">
                                                <input
                                                    type="text"
                                                    id="CREATE_BY" 
                                                    name="CREATE_BY"
                                                    className="form-control"
                                                    placeholder="รหัสพนักงาน, ชื่อ - สกุล"
                                                    value={searchConditionModel.CREATE_BY}
                                                    onChange={this.handleInputChange}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="rrs-detail-data">
                                            <label htmlFor="UNITCODE_CREATE" className="rrs-label mb-0">หน่วยงานผู้สร้าง MOM</label>
                                        </div>
                                        <div className="rrs-detail-data">
                                            <div className="form-group">
                                                <input
                                                    type="number"
                                                    id="UNITCODE_CREATE" 
                                                    name="UNITCODE_CREATE"
                                                    className="form-control"
                                                    placeholder="รหัสหน่วยงาน ตย. 80000636"
                                                    value={searchConditionModel.UNITCODE_CREATE}
                                                    onChange={this.handleInputChange}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                        
                                </div>
                                    


                            <div className="rrs-detail2">
                                <div className="rrs-form-group-search">
                                    <div className="row justify-content-center mx-0">

                                        <a onClick={ this.handleSearch } style={ { cursor: 'pointer' } }>
                                            <i className="icon btn-order-search"/>
                                        </a>
                                        <a onClick={ this.handleClear }
                                           style={ { cursor: 'pointer', marginLeft: 10, marginRight: 10 } }>
                                            <i className="icon btn-order-clear"/>
                                        </a>

                                    </div>
                                </div>
                            </div>
                            <br></br>
                            <div className="rrs-detail2">
                                <div className="sp-table-container">
                                    <div className="row no-gutters sp-table-content">
                                        <ReceiptTablePage
                                            tablesearch={ this.props.resultSearch }
                                            isAdmin={ this.state.isAdmin }
                                            { ...this.props }
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <DetailBotLogModal/>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => {
    const { SearchRedux } = state
    return {
        resultSearch: SearchRedux.resultSearch,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        searchReport: (searchCondition) => dispatch(searchReportReceiptAction(searchCondition)),
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(ReportReceiptScreen)